import React from "react";
import { Route, Switch } from "react-router-dom";
import TitleListPage from "../TitleListPage/TitleListPage";
import IssueListPage from "../IssueListPage/IssueListPage";
import IssuePage from "../IssuePage/IssuePage";
import EditTocPage from "../EditTocPage/EditTocPage";
import InspectPage from "../InspectPage/InspectPage";
import EditArticlePage from "../EditArticlePage/EditArticlePage";
import NoMatchPage from "../NoMatchPage/NoMatchPage";

function MainPage() {
  return (
    <Switch>
      <Route
        exact
        path={process.env.REACT_APP_URL_ROOT}
        component={TitleListPage}
      />
      <Route
        exact
        path={`${
          process.env.REACT_APP_URL_ROOT
        }titles/:titleID/:bookType(pdf_books|web_content_books)`}
        component={IssueListPage}
      />
      <Route
        exact
        path={`${
          process.env.REACT_APP_URL_ROOT
        }titles/:titleID/:bookType(pdf_books|web_content_books)/:issueID`}
        component={IssuePage}
      />
      <Route
        exact
        path={`${
          process.env.REACT_APP_URL_ROOT
        }titles/:titleID/:bookType(pdf_books|web_content_books)/:issueID/toc`}
        component={EditTocPage}
      />
      <Route
        exact
        path={`${
          process.env.REACT_APP_URL_ROOT
        }titles/:titleID/pdf_books/:issueID/inspect`}
        component={InspectPage}
      />
      <Route
        exact
        path={`${
          process.env.REACT_APP_URL_ROOT
        }titles/:titleID/:bookType(pdf_books|web_content_books)/:issueID/articles/:articleID`}
        component={EditArticlePage}
      />
      <Route component={NoMatchPage} />
    </Switch>
  );
}

export default MainPage;
